// extracted by mini-css-extract-plugin
module.exports = {"container":"loading_container__2Ncun","animation":"loading_animation__2eskC","loading":"loading_loading__1GRCx"};